<div class="warehouse-location-filter">
  <div [class.margin-right-8]="warehouses && warehouses.length > 0">
    <label>Warehouse</label>
    <ng-select
      [items]="warehouseList"
      bindValue="id"
      bindLabel="location_name"
      multiple="true"
      [(ngModel)]="warehouses"
      (change)="onWarehouseChange()"
      [loading]="loading"
    >
    </ng-select>
  </div>
  <div
    class="warehouse-location-filter__location"
    *ngIf="warehouses && warehouses.length > 0"
  >
    <label>Location</label>
    <ng-select
      [items]="locationList"
      bindValue="id"
      bindLabel="location_name"
      multiple="true"
      [(ngModel)]="locations"
      (change)="onLocationChange()"
      [loading]="locationLoading"
    >
    </ng-select>
  </div>
</div>
